"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DrawerItem = _styledComponents.default.div.attrs({
  "data-qa": "drawer-item"
}).withConfig({
  displayName: "MenuDrawerItem__DrawerItem",
  componentId: "l5o5aq-0"
})(["align-items:center;background-color:", ";border-bottom:1px solid ", ";display:flex;flex:1;min-height:50px;padding:20px 32px 19px 32px;"], function (props) {
  return props.theme.carvana.gray.background;
}, function (props) {
  return props.theme.carvana.gray.medium;
});

var MenuDrawerItem = function MenuDrawerItem(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react.default.createElement(DrawerItem, {
    className: className,
    "data-qa": "menu-drawer-item"
  }, children);
};

MenuDrawerItem.defaultProps = {
  className: ''
};
var _default = MenuDrawerItem;
exports.default = _default;
module.exports = exports.default;